import { Box } from '@mui/material';
import React, { ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import useOnClickOutside from '../hooks/useOnClickOutside';
import './shareLinkBubble.scss';

export const ShareLinkBubble = ({ children, show, width, height, onClose }: { children: ReactNode, show: boolean, width: number, height: number, onClose: () => any }) => {
    const htmlContainer = useRef();

    useOnClickOutside(htmlContainer, (e) => {
        if (show) {
            onClose();
        }
    });

    return <div ref={htmlContainer}>
        {show && <Box className="shareLinkBubble-root" onClick={(ev) => { ev.stopPropagation() }} width={width} height={height}>
            <div className="shareLinkBubble-container">
                <div className="bubble-arrow"></div>
                <div className="test">
                    {children}
                </div>
            </div>
        </Box>}
    </div>;
}